import React from "react";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import Card from "@mui/material/Card";
import Avatar from "@mui/material/Avatar";

import SubjectOutlinedIcon from "@mui/icons-material/SubjectOutlined"; // normal survey
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck"; // curated survey

import InputField from "./Components/InputField";
import { getInteractionByType } from "../User/Create/interactions";

function TitleQuestion({
  selected,
  onSelect,
  details,
  setDetails,
  handleBlock,
  disabled = false,
}) {
  const { t } = useTranslation();
  const isSelected = selected === "title";
  const interaction = getInteractionByType(details.itemExtra.interactionType);

  const onMouseDownHandler = () => onSelect("title");
  const handleTitleChange = (event) => {
    const value = event.target.value;
    let newDetails = { ...details };
    newDetails.fullQuestion = value;
    if (details.itemExtra.interactionType === 1) {
      // button
      newDetails.itemExtra.buttonText = value;
    }
    setDetails(newDetails);
    handleBlock("UPDATE_DETAILS");
  };

  const handleDescriptionChange = (event) => {
    const value = event.target.value;
    let newDetails = { ...details };
    let newDescription = details?.itemExtra?.description
      ? { ...details.itemExtra.description, description: value }
      : { description: value };
    newDetails.itemExtra.description = newDescription;
    setDetails(newDetails);
    handleBlock("UPDATE_DETAILS");
  };

  return (
    <Box paddingBottom={4} width="100%">
      <Card
        sx={{
          display: "flex",
          background: isSelected ? "rgb(248 248 248)" : "",
        }}
        variant="outlined"
        onMouseDown={onMouseDownHandler}
      >
        <Box width="15%" display="flex">
          <Avatar
            aria-label="questionnaire symbol"
            variant="rounded"
            sx={{
              backgroundColor: "rgba(255,255,255,0)",
              width: "100%",
              height: "100%",
              display: "flex",
              alignSelf: "flex-start",
              paddingTop: "6px",
              color: "#afafaf4a",
              margin: "auto",
            }}
          >
            <Box fontSize={100}>{<interaction.icon fontSize="inherit" />}</Box>
          </Avatar>
        </Box>
        <Box borderRight="1px solid rgba(0, 0, 0, 0.2)" />
        <Box width="100%">
          <Box padding={1} width="100%">
            <InputField
              type="title"
              inputValue={details.fullQuestion}
              placeholder={t("common.placeholders.title")}
              onChange={handleTitleChange}
              autoFocus={isSelected}
              disabled={disabled}
            />
            <InputField
              type="description"
              inputValue={details.itemExtra.description.description}
              placeholder={t("editor.placeholders.description")}
              onChange={handleDescriptionChange}
              disabled={disabled}
            />
          </Box>
        </Box>
      </Card>
    </Box>
  );
}

function titleQuestionIsSame(prev, next) {
  return JSON.stringify(prev.details) === JSON.stringify(next.details);
}

//export default React.memo(TitleQuestion, titleQuestionIsSame);
export default TitleQuestion;
